import axios from 'axios';

const otherincome = {   
	actions: {
        ProcessOtherIncome(context,userdata){
			return new Promise((resolve, reject) => {				
				axios.post('/OtherIncome/ProcessOtherIncome', userdata)
				.then(resp => resp.data)
				.then(respdata => {						
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},
		GetOtherIncome({rootState},{SessionId,TermId}){
			return new Promise((resolve, reject) => {				
				axios.get(`/OtherIncome/GetOtherIncome?SessionId=${SessionId}&TermId=${TermId}&Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
        },
		GetOtherIncomeById({rootState},Id){
			return new Promise((resolve, reject) => {				
				axios.get(`/OtherIncome/GetOtherIncomeById?Id=${Id}&Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
        },
		GetOtherIncomeBySearch({rootState},{SearchItem,SessionId,TermId}){
			return new Promise((resolve, reject) => {				
				axios.get(`/OtherIncome/GetOtherIncomeBySearch?SearchItem=${SearchItem}&SessionId=${SessionId}&TermId=${TermId}&Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
        },
        
	}
}

export default otherincome